module.exports = "data:video/mp4;base64,Cg=="


//////////////////
// WEBPACK FOOTER
// ./static/remote/intro-desktop.mp4
// module id = 328
// module chunks = 245 246